import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/common/services/api.service';

export class AppSettings {

    constructor()
    {


     }


}
